/**
 * Connected-Swarasense (W8): a tiny cross-module "is the app busy?" signal so
 * the auto-updater (`update-manager.ts`, run from `main.ts`) can hold a reload
 * until the user is idle — never mid-take or mid-range-finder. `app.ts`
 * registers a probe (its live mic engine's `running` state, which covers a
 * free/drill take, a sing-back, and the range-finder capture — all open the
 * mic). Decoupled: `update-manager.ts` imports only `isBusy`.
 */
let busyProbe: (() => boolean) | null = null;

/** Register the source of truth for "busy" — called once by `app.ts`. */
export function setBusyProbe(fn: () => boolean): void {
  busyProbe = fn;
}

/** Whether the app is mid-activity (a mic take/finder is running). `false` when
 * no probe is registered (e.g. before the app mounts, or in a content page). */
export function isBusy(): boolean {
  return busyProbe ? busyProbe() : false;
}
